// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bbv_a bhp_a bhp_q bhp_j bhp_wl bhp_bj","ImgResponsive__img":"bbv_b bhp_b bhp_ql"};